import classes from "./Intro.module.scss";
import { Link } from "react-scroll";

const Intro = (props) => {
  const { isDark } = props;
  return (
    <div className={classes.intro} id="intro">
      <h1
        className={classes.intro_heading}
        style={{
          backgroundColor: isDark ? "#090916" : "#fefefe",
          boxShadow: isDark
            ? "#090916 0px -22px 70px 4px, #090916 0px 22px 70px 4px"
            : "#fefefe 0px -22px 70px 4px, #fefefe 0px 22px 70px 4px",
        }}
      >
        Hello, I'm{" "}
        <span className={classes.intro_heading_fill}>Deexit Patel</span>
      </h1>
      <p
        className={classes.intro_subheading}
        style={{
          color: isDark ? "#fefefe" : "#090916",
          backgroundColor: isDark ? "#090916" : "#fefefe",
          boxShadow: isDark
            ? "#090916 -50px -22px 70px 4px, #090916 50px 22px 70px 4px"
            : "#fefefe -50px -22px 70px 4px, #fefefe 50px 22px 70px 4px",
        }}
      >
        A Frontend focused Web Developer building the Frontend of Websites and
        <br />
        Web Applications that leads to the success of the overall product
      </p>
      <Link
        activeClass="active"
        spy
        smooth
        to="about"
        className={
          isDark ? classes.intro_scrollButton : classes.intro_scrollButton_light
        }
      ></Link>
      <div
        className={classes.backgroundCircle}
        style={{
          border: isDark
            ? "3px solid rgba(254, 254, 254, 0.212)"
            : "3px solid rgba(9, 9, 22, 0.212)",
        }}
      >
        <div
          className={classes.innerCircle}
          style={{
            border: isDark
              ? "3px solid rgba(254, 254, 254, 0.212)"
              : "3px solid rgba(9, 9, 22, 0.212)",
            backgroundColor: isDark ? "#090916" : "#fefefe",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Intro;
